<template>
  <!-- footer -->
  <footer class="footer">
    <div class="container inner">
      <div class="bottom-wrapper">
        <div class="info-wrapper">
          <p>
            센터원 | 서울 용산구 용산동2가 5-84 |
            <span
              class="cursor"
              @click="openPage('https://carrotglobal.com/PrivacyPolicy')"
              >개인정보처리방침</span
            >
          </p>
          <p>
            대표이사 노상충 Copyright ⓒ<b>CARROT Global</b> Inc. All rights
            reserved.
          </p>
          <p>
            사업자 등록번호 211-88-50791 | 통신판매업 신고번호 제
            2017-서울강남-02979호 | 연락처 : 02-518-5467
          </p>
          <p>호스팅제공자 : 네이버 클라우드 | 개인정보관리책임자 : 김범진</p>
        </div>
        <div class="sns-family-wrapper">
          <div class="sns-wrapper">
            <p>FOLLOW US :</p>
            <ul>
              <li>
                <img
                  @click="
                    openPage(
                      'https://www.instagram.com/center_one_official/?img_index=1'
                    )
                  "
                  src="@/assets/img/newGlobal/main/footer/sns1.png"
                  alt="instagram"
                />
              </li>
              <li>
                <img
                  @click="openPage('https://blog.naver.com/center_one_')"
                  src="@/assets/img/newGlobal/main/footer/sns3.png"
                  alt="blog"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    openPage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
a,
img {
  display: block;
}

.container {
  width: calc(100% - 40px);
  max-width: 1200px;
  margin: 0 auto;
}

.cursor {
  cursor: pointer;
}

footer {
  background-color: #000000;

  .inner {
    padding: 20px 0;

    .bottom-wrapper {
      display: flex;
      flex-direction: column-reverse;
      gap: 20px 0;

      .info-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-size: 12px;
        color: #999999;

        a {
          display: inline-block;
          color: #999999;
        }
      }

      .sns-family-wrapper {
        font-size: 12px;
        color: #999999;

        .sns-wrapper {
          display: flex;
          align-items: center;
          gap: 0 5px;

          ul {
            display: flex;
            gap: 0 5px;

            li img {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  footer {
    .inner {
      padding: 50px 0;

      .bottom-wrapper {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 0;

        .sns-family-wrapper {
          display: flex;
          align-items: center;
          gap: 0 20px;
        }
      }
    }
  }
}
</style>
